export default "__VITE_ASSET__B1b$VYBt__"